import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import useOutsideClick from "hooks/click-outside";
import noInterestedFound from "assets/images/gifs/singing.gif";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

type WishlistItem = {
  id: number;
  userId: number;
  eventId: number;
  createdAt: string;
  updatedAt: string;
};

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  wishlistData: WishlistItem[];
  isLoading?: boolean;
};

const MembersInterestedPopup: React.FC<ModalProps> = ({ isOpen, onClose, wishlistData, isLoading = false }) => {
  const modalRef = useOutsideClick(onClose);
  console.log(wishlistData, "wishlistData");
  if (!isOpen) return null;

  return (
    <div
      className={`fixed z-40 inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div
        ref={modalRef}
        className={`relative bg-white px-6 py-8 rounded-lg shadow-lg w-[90%] sm:w-[380px] transform transition-transform duration-300 ${
          isOpen ? "scale-100" : "scale-95"
        }`}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full p-1 transition-all duration-200"
        >
          <AiOutlineClose size={18} />
        </button>

        <h2 className="text-base text-center text-primaryBlueText font-bold mb-4">
          Members interested in this Experience
        </h2>
        {isLoading ? (
          <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-10 w-10 border-2 border-primaryBlueText border-t-transparent"></div>
          </div>
        ) : (
          <>
            <div className="flex flex-col ">
              {wishlistData.map((wishlistItem: any, index) => (
                <div
                  key={wishlistItem.id}
                  className="flex items-center gap-4 bordr-linear py-4"
                >
                  <div>
                    <img
                      className="w-[45px] h-[45px] rounded-full"
                      src={concatPathWithBackendUrl(wishlistItem?.profilePicUrl)}
                      alt="userIcon"
                    />
                  </div>
                  <div className="flex flex-col items-center mt-2">
                    <h2 className="text-primaryBlueText font-semibold text-sm capitalize">
                     {wishlistItem?.firstName} {wishlistItem?.lastName}
                    </h2>
                    <p className="text-labelTextColor text-xs">
                     
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div className="my-5">
            <CustomMessageDisplay
                show={
                  !wishlistData.length
                }
                title="No Members Interested Yet"
                slogan="Be the first to show interest in this experience!"
                image={noInterestedFound}
                imageAlt="No members found"
                className="py-16"
                imageClassName="w-[150px] h-[120px]"
                titleClassName="text-2xl font-bold text-blackie"
                sloganClassName="text-gray-500 text-base"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MembersInterestedPopup;
